import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { updateItemAsync } from "actions/items";
import ImageEditor from "components/library/ImageEditor";

class SocialImageEditor extends React.Component {
  constructor(props) {
    super(props);
    this.onSuccess = this._onSuccess.bind(this);
  }

  _onSuccess(image) {
    return this.props.updateItemAsync(this.props.match.params.id, {
      social_image: image.id,
      head_rev: this.props.head_rev,
    });
  }

  render() {
    return (
      <ImageEditor
        {...this.props}
        redirectTo={`/editor/${this.props.match.params.type}/${
          this.props.match.params.id
        }/${this.props.match.params.type === "story" ? "social-seo/" : ""}`}
        onSuccess={this.onSuccess}
        skipMeta={true}
        cropRequirements={{
          "16x9": {},
        }}
      />
    );
  }
}

SocialImageEditor.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired,
    }),
  }),
  updateItemAsync: PropTypes.func.isRequired,
  head_rev: PropTypes.string,
};

const mapStateToProps = state => ({
  head_rev: state.editor.form.head_rev,
});

const mapDispatchToProps = {
  updateItemAsync,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SocialImageEditor);
